<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <b-media class="text-center ml-5 mr-5" v-if="!hasPatientRole && !hasSouscripteurRole">

            </b-media>
        </base-header>
        <b-container class="container-fluid mt--7">
            <b-row >
                <b-col col sm="12">
                    <div class="card shadow">
                        <div class="card-body">
                            <h3 class="text-center">{{$t('message.mesPatient')}}</h3>
                            <section class="container" id="appointment-table">
                                <div class="appointment-table-header my-2 mb-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-input-group
                                                    class="mb-3"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        class="p-2"
                                                        :placeholder="$t('message.search') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <div class="ml-1">
                                                <div class="d-flex">  
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="filteredCategory"
                                                             @change="typeFilterCategory(filteredCategory)" 
                                                            size="sm"
                                                            :options="filteredCategories"></b-form-select>      
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="filteredValue"
                                                            @change="typeFilter(filteredValue)"
                                                            size="sm"
                                                            :options="filtered"></b-form-select>                                               
                                                    <b-form-select
                                                            class="d-inline-block mr-2"
                                                            v-model="sortSelected"
                                                            size="sm"
                                                            :options="sortOptions"></b-form-select>
                                                    <div class="">
                                         

                                                     </div>
                                                    <div>
                                                        <b-button-group size="sm" class="mr-1">
                                                            <b-button
                                                                    :disabled="sortDirection === 'asc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='asc'"
                                                            >
                                                                <i class="fa fa-sort-amount-up-alt"></i>
                                                            </b-button>
                                                            <b-button
                                                                    :disabled="sortDirection === 'desc'"
                                                                    class="btn"
                                                                    size="sm"
                                                                    @click="sortDirection='desc'"
                                                            >
                                                                <i class="fa fa-sort-amount-down-alt"></i>
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 overflow-auto">
                                            <div class="ml-1">
                                                <div
                                                        v-if="paginationObject.numOfPages > 1"
                                                        class="pagination-wrapper d-inline-block"
                                                >
                                                    <div class="pagination">
                                                        <a
                                                                href="#"
                                                                :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('prev')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                        </a>
                                                        <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                            <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                            </template>
                                                            <template v-else>
                                                                <a
                                                                        href="#"
                                                                        :key="key"
                                                                        class="page-numbers"
                                                                        @click="_handlePaginationClick(pageNumber)"
                                                                >
                                                                    {{ pageNumber }}
                                                                </a>
                                                            </template>
                                                        </template>
                                                        <a
                                                                href="#"
                                                                class="next page-numbers"
                                                                :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                                @click="_handlePaginationClick('next')"
                                                        >
                                                            <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div  class="row appointment-table-content">
                                    <div class="container-fluid">
                                        <template
                                                v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0"
                                        >
                                            <div
                                                    v-for="(patient, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item hovered"
                                                    @click="onPatientPerInstCellClick({row: patient})"
                                            >
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $tc('message.patients', 1) }}
                                                        </span>
                                                    <h4 class="appointment-date">{{ patient.nom }}</h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.fileNumber') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.dossier }}
                                                    </h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.old') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.age }}
                                                    </h4>
                                                </div>
                                                <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.email') }}
                                                        </span>
                                                    <h4 class="appointment-hour">
                                                        {{ patient.email }}
                                                    </h4>
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else>
                                            <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                        </template>

                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';
    import { ModelSelect } from 'vue-search-select';
    import Swal from 'sweetalert2';
	import {pagination, handlePaginationClick, paginationDataProperty} from "../../helpers/paginations";

    export default {
        name: "MesPatients",

        computed: {
            ...mapGetters([
                "files",
                'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPatientRole',
                'hasSouscripteurRole',
                'hasAssistante'
            ]),

            mPatients:function () {
                let pArray = []; 
                let self = this;                     
                        // cardiologies 
                       _.forEach(this.files.cardiologies,function(cardiologie){
                            let p = {};
                            let dossier = cardiologie.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "cardiologies";
                                pArray.push(p);
                            }
                            
                        })
                        // kinesitherapie 
                       _.forEach(this.files.kinesitherapies,function(kinesitherapies){
                            let p = {};
                            let dossier = kinesitherapies.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "kinesitherapie";
                                pArray.push(p);
                            }
                            
                        })   
                        // hospitalisations 
                       _.forEach(this.files.hospitalisations,function(hospitalisations){
                            let p = {};
                            let dossier = hospitalisations.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "hospitalisations";
                                pArray.push(p);
                            }
                            
                        })  
                        // consultations_obstetrique 
                       _.forEach(this.files.consultationsObstetrique,function(consultations_obstetrique){
                            let p = {};
                            let dossier = consultations_obstetrique.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "consultations_obstetrique";
                                pArray.push(p);
                            }
                            
                        })  
                        // consultations_medecine 
                       _.forEach(this.files.consultationsMedecine,function(consultations_medecine){
                            let p = {};
                            let dossier = consultations_medecine.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "consultations_medecine";
                                pArray.push(p);
                            }
                            
                        })    
                       // Avis 
                       _.forEach(this.files.avis,function(avis){
                            let p = {};
                            let dossier = avis.dossier;
                            if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                p = self.formatDossier(dossier);
                                p.category = "avis";
                                pArray.push(p);
                            }
                            
                        })  
                        // mes Avis 
                       _.forEach(this.files.mesAvis,function(avis){
                            let p = {};
                            if(!_.isNull(avis.avis_medecin)){
                                let dossier = avis.avis_medecin.dossier;
                                if(dossier!==null && dossier.patient!==null && dossier.patient.user!==null){
                                    p = self.formatDossier(dossier);
                                    p.category = "mesAvis";
                                    pArray.push(p);
                                }
                                
                            }
                        })     

                return pArray;
            },
            rows: function() {
                return this.mPatients.length;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

        },

        components: {
            ModelSelect
        },

        data() {
            return {
                ...paginationDataProperty(this.$i18n),
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                mPatientsFilter : [],
                shouldDisplay: true,
                searchTerm : '',
                filteredCategories:[
                    {value:'Tous',text:'Tous'},
                    {value:"avis",text:'Avis medical créé'},
                    {value:"mesAvis",text:'Mes avis medical'},
                    {value:'consultations_obstetrique',text:'Consultations obstetrique'},
                    {value:"kinesitherapie",text:'Kinésithérapie'},
                    {value:"cardiologies",text:'Cardiologie'},
                    {value:"hospitalisations",text:'Hospitalisations'},
                    {value:"consultations_medecine",text:'Consultations medecine'},
                ],
                filteredCategory: '',
                filtered:[
                    {value:1,text:'Tous'},
                    {value:2,text:'Non Archivés'},
                    {value:3,text:'Non Transmis'},
                    {value:4,text:'Archivés'},
                    {value:5,text:'Transmis'},
                ],
                filteredValue:null,
                patientsColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'numero_dossier',
                        label: this.$i18n.t('message.fileNumber'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    /*{
                        field: 'sexe',
                        label: this.$i18n.t('message.gender'),
                    },*/
                    {
                        field: 'nationalite',
                        label: this.$i18n.t('message.nationality'),
                    },
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                    },
                ],

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                operationsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'element',
                        label: this.$i18n.tc('message.operations', 1)
                    },
                    {
                        field: 'action',
                        label: this.$i18n.t('message.action')
                    },
                ],

                patientPeInstitutionsColumns: [
                    {
                        label: this.$i18n.tc('message.patients', 1),
                        field: 'nom',
                    },
                    {
                        field: 'dossier',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'age',
                        label: this.$i18n.t('message.old')
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                ],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                offset: 0,
                limit: -1,
            }
        },

        watch:{
            item(newValue, lastValue){
                if (newValue.value != '0'){
                    this.onEtablissementClick(newValue.value);
                }
                else{
                    this.$store.dispatch('setselectedInstitution', { selectedInstitution : {} });
                }
            },


            filteredValues(sArray,value){
             this.typeFilter(this.filteredCategory,value);
            },

            filteredCategory(value){
             this.filteredCategory= value;
            },

            searchTerm:function (newValue, oldValue) {
                if (newValue.trim().length ==0){
                    this.patientPeInstitutionsRowsFilter = [];
                }else{
                    this.patientPeInstitutionsRowsFilter = this.mPatients;
                }

            },

			files: function (newValue, oldValue) {
				if (!this.shouldDisplay) {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				} else {
					this.currentPatientArray = [...this.mPatients];
					this.currentPatientArrayFiltered = this.currentPatientArray;
				}
			},

			currentPatientArray: function (newValue, oldValue) {
				this.paginationObject = pagination(newValue);
			},

			filterCriteria: function (newValue, oldValue) {
                
				if (newValue.length !== 0) {
					this.shouldDisplay = true;
					this.handleFilter(newValue);
				}
			},

			sortDirection: function (newValue, oldValue) {
				this.handleSort(this.sortSelected ,newValue);
			},

			sortSelected: function (newValue, oldValue) {
				this.handleSort(newValue, this.sortDirection);
			},

			shouldDisplay: function (newValue, oldValue) {
				if (newValue) {
					this.currentPatientArray = [...this.mPatients];
					this.currentPatientArrayFiltered = this.currentPatientArray;
				} else {
					this.currentPatientArray = [];
					this.currentPatientArrayFiltered = [];
				}
			}
        },

        methods:{
            onPatientClick(params){
                this.$router.push({ name: 'patient', params: { patient: params.row.slug } });
            },
			handlerOnFilterButton() {
				event.preventDefault();
				this.handleFilter(this.filterCriteria);
			},

			_handlePaginationClick(action) {
				this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
			},

			handleFilter(value) {
				if (value) {
					const newCurrentPatientArray = this.currentPatientArray.filter(app => {
						let result = false;

						if (app.nom) {
							result = result || app.nom.toLowerCase().includes(value.toLowerCase());
						}

						if (app.dossier) {
							result = result || app.dossier.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.age) {
							result = result || app.age.toString().toLowerCase().includes(value.toLowerCase());
						}

						if (app.email) {
							result = result || app.email.toLowerCase().includes(value.toLowerCase());
						}

						return result;
					});

					this.currentPatientArrayFiltered = newCurrentPatientArray;

					this.paginationObject = pagination(newCurrentPatientArray);
				} else {
					this.currentPatientArrayFiltered = this.currentPatientArray;
					this.paginationObject = pagination(this.currentPatientArray);
				}
                this.filteredValues(null,this.paginationObject);
			},

			handleSort(value, sortDirection = 'asc') {
				if (value) {
					let newCurrentPatientArray = [];
					const sortType = ['nom', 'dossier', 'age', 'email'];
					const restOfType = sortType.filter(i => i !== value);

					const sortDirectionType = ['asc', 'desc'];
					const restOfSortDirectionType = sortDirectionType.filter(i => i !== sortDirection);

					newCurrentPatientArray = _.orderBy(this.currentPatientArrayFiltered, [value, ...restOfType], [sortDirection, ...restOfSortDirectionType]);

					this.paginationObject = pagination(newCurrentPatientArray);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
            typeFilterCategory(type) {
                let value =[];
                if(type === "Tous"){
                    value = this.currentPatientArrayFiltered;
                }else{
                    value = _.filter(this.currentPatientArrayFiltered,function (medecine) {
                    return medecine.category === type;
                    })
                }
				if (value) {
					this.paginationObject = pagination(value);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			typeFilter( cat) {

               let value = {};
               let tab = [];
               let self = this;
            //    console.log(this.currentPatientArrayFiltered);
                            value = _.filter(this.files.consultationsMedecine,function (medecine) {
                                let dossier = medecine.dossier;
                                let newValue = self.formatDossier(dossier);
                                newValue.category = "consultations_medecine";
                                return newValue;
                            })
                            // console.log(value);
                            // let dossier = medecine.dossier;
                            // med = self.formatDossier(dossier);
                            // med.category = "consultations_medecine";
                            if(this.filteredValue == 1){
                                value = _.filter(value,function (medecine) {
                                    let dossier = medecine.dossier;
                                    let newValue = self.formatDossier(dossier);
                                    // console.log(medecine);
                                return !_.isNull(medecine);
                            })
                            }else if (this.filteredValue == 2){
                            //Non archivés
                            value = _.filter(value,function (medecine) {
                                let dossier = medecine.dossier;
                                let newValue = self.formatDossier(dossier);
                                // console.log(medecine);
                            return _.isNull(medecine.archieved_at);
                            })
                            // console.log(value);
                        }else if (this.filteredValue == 3){
                            //Non transmis
                            value = _.filter(value,function (medecine) {
                                let dossier = medecine.dossier;
                                let newValue = self.formatDossier(dossier);
                                // console.log(medecine);
                            return _.isNull(medecine.passed_at) ;
                            })
                            // console.log(value);
                        }else if (this.filteredValue ==4){
                            //Archivés
                            value = _.filter(value,function (medecine) {
                                let dossier = medecine.dossier;
                                let newValue = self.formatDossier(dossier);
                                // console.log(medecine);
                            return !_.isNull(medecine.archieved_at) ;
                            })
                            // console.log(value);
                        }else if (this.filteredValue == 5){
                            //Transmis
                            value = _.filter(value,function (medecine) {
                                let dossier = medecine.dossier;
                                let newValue = self.formatDossier(dossier);
                                // console.log(medecine);
                            return !_.isNull(medecine.passed_at);
                            })
                            // console.log(value);
                        }
                        let dossier = value.forEach((elt) => {
                            let p = {};
                            let prenom = elt.dossier.patient.user.prenom ? elt.dossier.patient.user.prenom : '';
                            prenom =  prenom.toLowerCase();
                            p.nom =  (elt.dossier.patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            p.dossier = elt.dossier.numero_dossier;
                            // p.nom = elt.dossier.patient.user.nom;
                            p.email = elt.dossier.patient.user.email;
                            p.slug = elt.dossier.patient.user.slug;
                            p.fileSlug = elt.dossier.slug;
                            p.age =  moment().year() - moment(elt.dossier.patient.date_de_naissance).year();
                            tab.push(p);
                        });
                        // console.log(tab);
                        // console.log(value.dossier);
                        // value = self.formatDossier(dossier);
                        // value = tab;
				if (tab) {
					this.paginationObject = pagination(tab);
				} else {
					this.paginationObject = pagination(this.currentPatientArrayFiltered);
				}
			},
			onEtablissementClick(etablissementId){
                let etablissement = _.filter(this.institutions,function (institution) {
                    return institution.id == etablissementId;
                });
                this.$store.dispatch('setselectedInstitution', { selectedInstitution : etablissement });
            },

            onOperationClick(params){
                // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.fileSlug } })).href +  '#generale');

            },

            onPatientPerInstCellClick(params){
                // if (params.column.field == "institution")
                //     this.$router.push({ name: 'institution', params: { institution: params.row.institutionSlug } });
                // else
                let isPraticienPatient=_.find(this.mUserInstitutions,function (institution) {

                    let patient = _.find(institution.patients, function (patient) {
                        return  patient.user_id == params.row.id;
                    });
                    if(_.isUndefined(patient))
                        return patient;
                    return institution;
                });

                if (_.isUndefined(isPraticienPatient)){
                    Swal.fire({
                        title: 'Êtes vous sûr ?',
                        text: "Ce patient n'appartient pas à l'un de vos établissements. Vous serez fichié dans le système si vous y accédez",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#00ada7',
                        cancelButtonColor: '#f5365c',
                        confirmButtonText: 'Oui, accédez!'
                    }).then((result) => {
                        if (result.value) {
                            // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                            this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                        }
                    })
                }else{
                    // this.$router.push({ name: 'medical-file', params: { file: params.row.fileSlug } });
                    this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file:params.row.fileSlug } })).href +  '#generale');

                }
            },
            formatDossier:function(dossier){
                // console.log(dossier);
                        let p = {};
                        if (typeof dossier == 'object') { 
                            if(!_.isNull(dossier.patient)) {
                                if(!_.isNull(dossier.patient.user)) {
                                    let prenom = dossier.patient.user.prenom ? dossier.patient.user.prenom : '';
                                    prenom =  prenom.toLowerCase();
                                    p.nom =  (dossier.patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                                    p.dossier = dossier.numero_dossier
                                    p.email = dossier.patient.user.email;
                                    p.telephone = dossier.patient.user.telephone;
                                    p.age = moment().year() - moment(dossier.patient.date_de_naissance).year();
                                    p.sexe = dossier.patient.sexe;
                                    p.nationalite = dossier.patient.user.nationalite;
                                    p.ville = dossier.patient.user.ville;
                                    p.pays = dossier.patient.user.pays;
                                    p.date = moment(dossier.patient.user.date_de_naissance).format('DD-MM-YYYY');
                                    p.id = dossier.patient.user.id;
                                    p.slug = dossier.patient.user.slug;
                                    p.adresse = dossier.patient.user.adresse;
                                    p.fileSlug = dossier.slug;
                                }  
                            }  
                            
                           
                        }
                        return p;
            },
            notEmpty(item){
                return item.length > 0;
            },

            getInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getInstitutions', { args : args });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            getLatestOperation() {
                let args = {

                };

                this.$store.dispatch('getOperations', { args : args });
            },


            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                // this.$router.push({ name: 'patient', params: { patient: item.selectedObject.slug } });
                this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: item.selectedObject.fileSlug } })).href +  '#generale');
                // this.$router.push({ name: 'medical-file', params: { file: item.selectedObject.fileSlug } });
            },

            formatString(item){
                return item.length > 36 ? item.substr(0, 36) + '...' : item;
            },
            
            getMyPatient() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getMyMedicalFile', { args : args });
            },
        },

        mounted() {
            // Fetch patient list
            this.getMyPatient();
        }
    }
</script>

<style scoped>
</style>